import React from "react";
import { FaWhatsapp, FaFilePdf } from "react-icons/fa";
import "../css/TypesOfScholarships.css";

const TypesOfScholarships = () => {
  const scholarshipsData = [
    {
      id: 1,
      title: "Dr. APJ Abdul Kalam Merit Scholarship",
      description:
        "This scholarship celebrates the achievements of students in the world of science, digital technology, and other creative fields which require students to apply themselves to innovative pursuits from a young age.",
      curricula: "CBSE",
      grades: "Grade 6 - 12",
      tenure: "1 Year",
      image: "../images/a.jpeg",
      isClosed: true,
    },
    {
      id: 2,
      title: "Sahara Sports & Athletics Talent Scholarship",
      description:
        "Recognizing outstanding young athletes who have excelled in sports, martial arts, or team events at regional and national levels, helping them balance sports and academics.",
      curricula: "CBSE / National Board",
      grades: "Grade 1 - 12",
      tenure: "1 Year (Renewable)",
      image: "../images/b.jpeg",
      isClosed: false,
    },
  ];

  const testimonialsData = [
    {
      id: 1,
      text: "Sahara Public Secondary School has demonstrated absolute excellence in teaching with modern interactive methodologies, ensuring the overall holistic development of pupils.",
      author: "Mr. Nikesh Patel",
      relation: "Father of Tathya Nikesh Patel",
      avatar: "../images/c.jpg",
    },
    {
      id: 2,
      text: "The support and guidance from the teachers during crucial academic years helped my daughter achieve stellar board results while continuing her basketball training.",
      author: "Mrs. Anjali Shrestha",
      relation: "Mother of Sneha Shrestha",
      avatar: "../images/d.jpeg",
    },
  ];

  return (
    <section className="types-scholarship-section">
      {}
      <div className="section-intro-header">
        <h2 className="main-section-title">Types of Scholarships</h2>
        <p className="main-section-desc">
          At Sahara Public Secondary School, we believe in recognizing and
          nurturing talent across academics, sports, and leadership. To support
          meritorious students, we offer a variety of scholarships tailored to
          different skill sets and achievements.
        </p>
      </div>

      {}
      <div className="two-col-layout-container">
        {}
        <div className="left-testimonials-panel">
          <h3 className="panel-title-text">Testimonials</h3>

          <div className="testimonials-stack">
            {testimonialsData.map((testimonial) => (
              <div key={testimonial.id} className="parent-testimonial-card">
                <div className="avatar-frame">
                  <img src={testimonial.avatar} alt={testimonial.author} />
                </div>
                <p className="testimonial-quote">"{testimonial.text}"</p>
                <div className="author-details">
                  <h4 className="author-name">{testimonial.author}</h4>
                  <p className="author-relation">{testimonial.relation}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {}
        <div className="right-scholarships-panel">
          {scholarshipsData.map((scholarship) => (
            <div key={scholarship.id} className="scholarship-horizontal-card">
              {}
              <div className="card-image-box">
                {scholarship.isClosed && (
                  <div className="status-ribbon-tag">CLOSED</div>
                )}
                <img
                  src={scholarship.image}
                  alt={scholarship.title}
                  className="scholarship-main-img"
                />
              </div>

              {}
              <div className="card-details-box">
                <h3 className="scholarship-card-title">{scholarship.title}</h3>
                <p className="scholarship-card-desc">
                  {scholarship.description}
                </p>

                <div className="curricula-tag-section">
                  <span className="info-label">Curricula Offered:</span>
                  <div className="badge-pill">{scholarship.curricula}</div>
                </div>

                <div className="meta-info-grid">
                  <div>
                    <span className="info-label">Grades Offered:</span>
                    <p className="info-value-text">{scholarship.grades}</p>
                  </div>
                  <div>
                    <span className="info-label">Tenure:</span>
                    <p className="info-value-text">{scholarship.tenure}</p>
                  </div>
                </div>


                {}
                <div className="card-footer-action-links">
                  <a
                    href="https://wa.me/yournumber"
                    className="footer-link-item"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaWhatsapp className="link-icon-ws" /> Speak to our
                    Scholarship Expert
                  </a>
                  <a href="/brochure.pdf" className="footer-link-item" download>
                    <FaFilePdf className="link-icon-pdf" /> Request for
                    Scholarship Brochure
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TypesOfScholarships;
